// Display names for dashboard sections, shared by the card titles and the refresh
// popups so the two always match. Add new widgets here.
export const DASHBOARD_SECTIONS = {
  summary: 'Summary',
  attention: 'Needs attention',
  trends: 'Activity trends',
  inventory: 'Live ads by warehouse',
  recent: 'Recent',
  system: 'System',
};
